import { connect } from 'react-redux';

import decorate from '../../../utils/decorate';
import { AuditList } from './AuditList.tsx';
import { request as onQueryAuditsRequest } from '../../../modules/audits/actions/query';

function mapStateToProps(state, props) {
    const audits = state.audits.getIn(['collections', props.id ]) || new Map();
    const total = audits.get ? audits.get('total') : 0;
    const query = audits.get ? audits.get('query') : null;

    return {
        audits,
        total,
        query,
        appState: global.$appState || window.$appState,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onQueryAuditsRequest: (id, query, filterTab) => dispatch(onQueryAuditsRequest(id, query, filterTab))
    };
}

export default decorate(connect(mapStateToProps, mapDispatchToProps), AuditList);
